import { gettext } from '@eventbrite/i18n';

export const SectionsIds = {
    ABOUT: gettext('about'),
    EVENTS: gettext('events'),
    COLLECTIONS: gettext('collections'),
} as const;
